import { forwardRef } from "react";

import { Checkbox, CheckboxProps, CheckboxSubComponents, RefComponent } from "capitalrx-components-2.0/lib/forms";
import { Field } from "capitalrx-components-2.0/lib/forms/Checkbox/Field";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/Checkbox/Placeholder";
import { withSubComponents } from "capitalrx-components-2.0/lib/utilities";
import styled from "styled-components";

import "./Checkbox.scss";

const _ThemedCheckboxField = styled(Field)`
  .checked,
  .check {
    &:focus {
      box-shadow: 0px 0px 4px ${(props) => props.theme.primary_button_color} !important;
    }
  }

  .checked {
    .check-container {
      background-color: ${(props) => props.theme.primary_button_color} !important;
      border-color: ${(props) => props.theme.primary_button_color} !important;
    }
  }
`;

const _ThemedCheckbox = styled(Checkbox)`
  .checked,
  .check {
    &:focus {
      box-shadow: 0px 0px 4px ${(props) => props.theme.primary_button_color} !important;
    }
  }

  .checked {
    .check-container {
      background-color: ${(props) => props.theme.primary_button_color} !important;
      border-color: ${(props) => props.theme.primary_button_color} !important;
    }
  }
`;

interface ThemedCheckboxSubComponents extends CheckboxSubComponents {
  readonly Field: typeof _ThemedCheckboxField;
}

export const ThemedCheckbox = withSubComponents<RefComponent<HTMLInputElement, CheckboxProps>, ThemedCheckboxSubComponents>(
  {
    Field: _ThemedCheckboxField,
    Placeholder,
  },
  forwardRef(function FRThemedCheckbox(props, ref) {
    return <_ThemedCheckbox {...props} ref={ref} />;
  }),
);
